
<script>
import appConfig from "@/app.config";
import CollectingData from "./collectingData.vue";
import GiftWinner from "@/router/views/gift/gift-winner";
import BrowserType from "./browserType.vue";
import DeviceOs from "./deviceOs.vue";
import AgeRangeRate from "./ageRangeRate.vue";
import GenderRate from "./genderRate.vue";
import CustomDropDownRate from "./customDropDownRate.vue";
import DoubleBarChart from "./DoubleBarChart.vue";
import CampaignProgressRate from "./campaignProgressRate.vue";
import GroupSparkLine from "./groupSparkLine.vue";
import TimeLineCampaign from "./timeLineCampaign.vue";
import MovmentBag from "./movmentBag.vue";
import CampaignApi from "@/services/campaign-api";
import ReportingApi from "@/services/reporting-api";
import CountCollectingDataByDaySplineChart from "./countCollectingDataByDaySplineChart.vue";
import SettingsQrCampaign from "@/components/SettingsQrCampaign";
import Vue from 'vue'
import Swal from "sweetalert2";

//import QrcodeVue from 'qrcode.vue';
//import DistributionState from "./distributionState.vue";
//import SplineChart from "./splineChart.vue";
//import BarChart from "./BarChart.vue";


/**
 * Reporting component
 */
export default {
  page: {
    title: "Les Rapports",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {SettingsQrCampaign, CollectingData, BrowserType, DeviceOs,CountCollectingDataByDaySplineChart,/* BarChart, SplineChart, DistributionState,*/ GenderRate, CampaignProgressRate, GroupSparkLine, TimeLineCampaign, MovmentBag, DoubleBarChart, AgeRangeRate, CustomDropDownRate, GiftWinner  /*QrcodeVue*/},

  mounted(){
    this.findCampaignByCurrentCustomer()

    var date = new Date();

    this.start = new Date(date.getFullYear(), date.getMonth(), 1);
    const startoffset = this.start.getTimezoneOffset()
    this.start= new Date(this.start.getTime() - (startoffset*60*1000))
    this.start=this.start.toISOString().split('T')[0]

    this.end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const endoffset = this.end.getTimezoneOffset()
    this.end= new Date(this.end.getTime() - (endoffset*60*1000))
    this.end=this.end.toISOString().split('T')[0]




  },

  data() {
    return {
      pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
      isGetTrackingStarting: false,
      start:null,
      end:null,
      showError:null,

      showConfigureQRCode: false,

      userAgentAnalysis:{browserFrequency:null , osFrequency: null},
      coverageCollectingRate:null,
      globalScanRate:null,
      campaignProgressRate:null,
      deliveredByWeek:null,
      scanByDay:null,
      totalsData:null,
      campaignList: [],
      selectedcampaign:null,
      cumulativeData:null,
      deliveredByCity:null,
      totalDelivered:null,
      ageRangeRate:null,
      genderRate:null,
      customDropDownRate:null,
      showCampaignList:false,
      isCampaignTableBusy: false,
      campaignReport:null,
      countCollectingDataByDay:null,
      imagesMap: {}, 
      vediosMap: {}, 
      qrSettingsOpen: false,

      imageVideoIndex:0,

            campaignListFields:  [

                { key:"timeStamp", label: "",thClass:"text-left d-md-table-cell d-none",tdClass:"text-left d-md-table-cell d-none" },
                { key:"name", label: "",   sortable: false, tdClass:"font-weight-bold ",thStyle:"min-width:150px"},
                { key:"start", label: "",   sortable: false, tdClass:"font-weight-bold ", thStyle:"min-width:120px"},
                { key:"end", label: "",   sortable: false, tdClass:"font-weight-bold ",thStyle:"min-width:120px"},
                { key:"quantityBagAsString", label: "",thClass:"text-right d-md-table-cell d-none",tdClass:"text-right d-md-table-cell d-none" },
                { key:"actions", label:"",thClass:"text-right d-md-table-cell ",tdClass:"text-right d-md-table-cell "}

        ],
    
    };
  },

  watch:{

    selectedcampaign:function(){
      this.showConfigureQRCode = false
      this.refresh()

    },

    },

  methods: {

    toggleQRCodeSettings() {
      this.qrSettingsOpen = !this.qrSettingsOpen;
      this.configureQRCode();
    },

    refresh(){
      this.getCampaignReport()
    },

    findMediaByCode(code , isImage) {
      CampaignApi.findMediaByCode(code).then((result)=>{
          if(result){
              if(isImage){
                this.$set(this.imagesMap, code , result );
              }else{
                this.$set(this.vediosMap, code , result );
              }
          }
      });
    },

    repeatExperience(){
      Swal.fire({
        html: this.$t('campaign.swalTitle'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#d11010",
        confirmButtonText: "Oui, envoyer",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.value) {
          CampaignApi.repeatExperience(this.selectedcampaign.id).then(result=>{
            if(result){
              Vue.prototype.$snotify.success(this.$t('campaign.sNotifyRepeatExperiance'))
            }
          })
        }
      });
    },


    downloadQRCode() {
      this.$nextTick(() => {

        const svgElement = this.$refs.qrCode.$el.querySelector("svg");

        if (svgElement) {
          const serializer = new XMLSerializer();
          const svgString = serializer.serializeToString(svgElement);
          const svgBlob = new Blob([svgString], { type: "image/svg+xml" });
          const url = URL.createObjectURL(svgBlob);

          const link = document.createElement("a");
          link.href = url;
          link.download = "qrcode.svg";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url); // Clean up the URL object
        } else {
          console.error("SVG element not found.");
        }
      });
    },

    configureQRCode() {
      this.showConfigureQRCode = !this.showConfigureQRCode ;
    },

    onRowClicked(item) {
      this.selectedcampaign = item;
      this.showCampaignList = false;
    },

    findCampaignByCurrentCustomer(){
      this.isCampaignTableBusy = true 
      CampaignApi.findCampaignByCurrentCustomer(this.pagemodelMain.currentPage, this.pagemodelMain.perPage).then(result =>{
              if(result){

                this.campaignList= result.list
                this.pagemodelMain.totalRows = result.total;
                this.pagemodelMain.currentPage = result.page;
                this.pagemodelMain.perPage = result.pageSize;
                this.pagemodelMain.pageSize = result.pageSize;

                this.selectedcampaign = this.campaignList[0]
                this.isCampaignTableBusy = false 

              }

            })
        },

        clearCampaignReport(){
          this.campaignReport = null
          this.userAgentAnalysis = null,
          this.campaignProgressRate =null,
          this.globalScanRate = null, 
          this.coverageCollectingRate =null,
          this.deliveredByWeek =null,
          this.scanByDay =null,
          this.totalsData =null,
          this.cumulativeData =null,
          this.deliveredByCity =null,
          this.totalDelivered =null,
          this.ageRangeRate =null,
          this.genderRate = null
          this.customDropDownRate = null
          this.countCollectingDataByDay = null

        },

        loadMoreImages() {

          this.imagesMap = {};
          this.vediosMap = {};

          for (let i = 0; i < this.selectedcampaign.imagesCampaign.length; i++) {
            const im = this.selectedcampaign.imagesCampaign[i];
            this.findMediaByCode(im, true);
          }

          for (let i = 0; i < this.selectedcampaign.videoCampaign.length && i; i++) {
            const im = this.selectedcampaign.videoCampaign[i];
            this.findMediaByCode(im, false);
          }

          /*const imagesToLoad = 6; // Number of images to load per call
          let imagesLoaded = 0;

          console.log(this.imageVideoIndex)

  // Load images first
  for (let i = this.imageVideoIndex; i < this.selectedcampaign.imagesCampaign.length && i < this.imageVideoIndex + imagesToLoad; i++) {
    const im = this.selectedcampaign.imagesCampaign[i];
    this.findMediaByCode(im, true); // true indicates loading an image

    // Increment counter after each image load
    imagesLoaded++;
  }

        // After loading images, check if all images are loaded, then load videos
      if (imagesLoaded === imagesToLoad || this.imageVideoIndex + imagesToLoad >= this.selectedcampaign.imagesCampaign.length) {
        for (let i = this.imageVideoIndex; i < this.selectedcampaign.videoCampaign.length && i < this.imageVideoIndex + imagesToLoad; i++) {
          const im = this.selectedcampaign.videoCampaign[i];
          this.findMediaByCode(im, false); // false indicates loading a video
        }


          // Update the imageVideoIndex to load the next batch in the next call
          this.imageVideoIndex += imagesToLoad;
      }*/
    },
      

        getCampaignReport(){
          this.clearCampaignReport()
          ReportingApi.getCampaignReport(this.selectedcampaign == null ? null : this.selectedcampaign.id).then(result => {
            if (result) {
              this.campaignReport = result
              this.userAgentAnalysis = this.campaignReport.userAgentAnalyseData || null,
              this.campaignProgressRate = this.campaignReport.campaignProgressRate || null,
              this.globalScanRate = this.campaignReport.scansRate || null,
              this.coverageCollectingRate = this.campaignReport.collectDataRate || null,
              this.deliveredByWeek = this.campaignReport.deliveredByWeek || null,
              this.scanByDay = this.campaignReport.scanByDay || null,
              this.totalsData = this.campaignReport.globalData || null,
              this.cumulativeData = this.campaignReport.deliveredScansBags || null,
              this.deliveredByCity = this.campaignReport.distributedBagsByCity || null,
              this.totalDelivered = this.campaignReport.totalDelivered || null,
              this.ageRangeRate = this.campaignReport.ageRangeRate || null,
              this.genderRate = this.campaignReport.genderRate || null,
              this.customDropDownRate = this.campaignReport.customDropDownRate || null,
              this.countCollectingDataByDay = this.campaignReport.countCollectingDataByDay || null,
              this.showError = false
            } else {
              this.clearCampaignReport()
              this.showError = true
            }
          }).finally(() => {
            

            
            if(this.selectedcampaign && this.selectedcampaign.imagesCampaign){
              this.loadMoreImages();
            }

            

          })
        },

  }
};
</script>

<template>
<div class="home-page-80-width"> 
     <div >
      <!-- Header -->
      <div v-if="campaignReport && campaignReport.globalData " class="row mb-md-4 mb-0 p-md-0 p-3">
        <div class="col-12 col-sm-4">
          <h1 class="text-primary font-weight-bold text-uppercase">{{selectedcampaign.name}} </h1>

          <h5 class="text-primary text-uppercase font-size-20">
            {{ selectedcampaign.customerName }}

            <b-button variant="light" @click="showCampaignList = true" class="btn-sm shadow-sm px-4 font-weight-bold text-uppercase font-size-12 ml-2">
                {{ $t('campaign.change') }}
            </b-button>

            <!--b-button variant="light" @click="getCampaignReport" class="btn-sm shadow-sm px-4 font-weight-bold text-uppercase font-size-12 ml-2">
                {{ $t('campaign.refresh') }}
            </b-button--> 

          </h5>

          <h5 class="text-dark font-size-16 mt-4">
            {{ $t('periode.start') }} <strong>{{ campaignReport.startDate }}</strong>  {{ $t('periode.end') }} <strong>{{ campaignReport.endDate }}</strong>
            <p class="text-secondary font-size-12 mt-1" > {{ $t('campaign.text.lastEventDate') }} <strong v-if="campaignReport.lastEventTimeStamp ">{{this.campaignReport.lastEventTimeStamp}}</strong> </p>

          </h5>

          <h5 class="text-dark font-size-14 mt-4" v-if="!this.selectedcampaign.campaignWithOutBags"> 
            {{ $t('campaign.bagsOrdered') }} : <strong>{{this.selectedcampaign.quantityBagAsString}}</strong> {{ $t('campaign.bags') }}
          </h5>
          <h5 class="text-dark font-size-14" v-if="!this.selectedcampaign.campaignWithOutBags && this.totalsData.countZone"> 
            {{ $t('campaign.countZone') }} : <strong>{{this.totalsData.countZone}}</strong> {{ $t('campaign.zone') }}
          </h5>
          <h5 class="text-dark font-size-14" v-if="!this.selectedcampaign.campaignWithOutBags"> 
            {{ $t('campaign.countPartner') }} : <strong>{{this.totalsData.countPartner}}</strong> {{ $t('campaign.partner') }}
          </h5>

        
        </div>

        <div  class="col-12 col-sm-4 mt-md-0 mt-4 text-center">
          <img  v-if="selectedcampaign && selectedcampaign.bagsModel && !this.selectedcampaign.campaignWithOutBags"  alt="" style="max-width: 350px;"  width="100%" height="auto"  v-bind:src="'/api/image/get/menu/small/' + selectedcampaign.bagsModel"  />    
        </div>

        <div class="col-12 col-sm-4 mt-5 mb-md-4 mb-0 mt-sm-0 mb-sm-0 d-flex flex-column justify-content-center text-md-right text-center">
  
          <!-- <div>
            <a class="text-secondary" @click="refresh" >
              <b-button variant="light" class=" shadow-sm px-4 font-weight-bold text-uppercase font-size-12 ml-2 float-right mb-2" style="width: 250px;" >
                <img width="15px" class="mr-1" src="@/assets/icons/refresh.svg" style="cursor: pointer;" />
                {{ $t('campaign.refresh') }}
              </b-button> 
            </a>
          </div> -->

          <div v-if="selectedcampaign.code">

            <a class="text-secondary" :href="selectedcampaign.urlCode" target="_blank">
              <b-button variant="outline-secondary" class="mt-2" style="width: 250px;">
                {{$t("campaign.text.preview")}}
              </b-button> 
            </a>
          </div>

          <div>
            <b-button variant="outline-info text-uppercase" class="mt-2" style="width: 250px;" @click="repeatExperience()">
              {{$t("campaign.text.refaire")}}
            </b-button> 
          </div>
          
          <div>
            <router-link to="/devis">
              <b-button variant="outline-primary text-uppercase" class="mt-2" style="width: 250px;">
                {{$t("campaign.text.new")}}
              </b-button>
            </router-link>
 
          </div>
          <div>
          <b-button
            v-if="selectedcampaign && (selectedcampaign.campaignWithOutBags || selectedcampaign.isMenuCampaign)"
            :variant="qrSettingsOpen ? 'primary text-uppercase' : 'outline-primary text-uppercase'"
            class="mt-2"
            style="width: 250px;"
            @click="toggleQRCodeSettings"
          >
            <template v-if="qrSettingsOpen">
              <img alt="arrow-left" width="20px" src="@/assets/icons/arrow-left-2-w.svg" />
              {{ $t('campaign.card.return') }}
            </template>
            <template v-else>
              {{ $t('campaign.card.qrSettings') }}
            </template>
          </b-button>
          </div>
          <div v-if="selectedcampaign && (selectedcampaign.campaignWithOutBags && selectedcampaign.isMenuCampaign && selectedcampaign.isMenuCampaignWithOrder )">
           <a :href="'/menu-order/' + selectedcampaign.menuCode"
              target="_blank"
              rel="noopener noreferrer"
            >
              <b-button variant="outline-primary text-uppercase" class="mt-2" style="width: 250px;">
                {{ $t('campaign.card.menuOrder') }}
              </b-button>
            </a>

          </div>
        </div>
      </div>
      <!-- End Header -->
      
      <div v-if="!showConfigureQRCode"  >

      <!-- Counts -->
      <GroupSparkLine class="mt-md-4 mt-0 p-md-0 p-3" :totalsData="totalsData" :campaignWithOutBags="campaignReport && campaignReport.campaignWithOutBags"/>
      
      <!-- Coverage Rates -->
      <CampaignProgressRate class="mt-md-5 mt-2 p-md-0 p-3" :coverageCollectingRate="coverageCollectingRate" :campaignWithOutBags="campaignReport && campaignReport.campaignWithOutBags" :globalScanRate="globalScanRate" :campaignProgressRate="campaignProgressRate"/>

      <!-- Scans QR Codes / jour -->
      <div class="row mt-md-5 mt-2 p-md-0 p-3" v-if="scanByDay">
          <div class="col-lg-6 col-12 pr-lg-2" >
            <DoubleBarChart 
            :campaignId="this.selectedcampaign.id"
            :name="$t('campaign.label.series1BarChart')" :name1="$t('campaign.label.series2BarChart')"
            :data="scanByDay.entryCount" :data1="scanByDay.uniqueScans" :categories="scanByDay.date" :title="$t('campaign.card.scanByDay')"
            ></DoubleBarChart>
          </div>
          <div   class="col-lg-6 col-12 mt-4 mt-lg-0 pl-lg-2" >
                <CountCollectingDataByDaySplineChart
                :campaignId="this.selectedcampaign.id"
                :countCollectingDataByDay="countCollectingDataByDay == null ? null : countCollectingDataByDay"  :title="$t('campaign.card.countCollectingDataByDay')" />
          </div>

          <!-- <div class="col-lg-6 col-12 mt-4 mt-lg-0 pl-lg-2" v-if="deliveredByWeek">
            <BarChart :data="deliveredByWeek.totalQuantityBags" :categories="deliveredByWeek.date" :title="$t('campaign.card.deliveredByWeek')"></BarChart>
          </div> -->
        </div>

        <!-- device & UserAgent -->
        <div class="row mt-md-5 mt-2 p-md-0 p-3" v-if="userAgentAnalysis &&  ((userAgentAnalysis.browserFrequency && Object.keys(userAgentAnalysis.browserFrequency).length > 0) || (userAgentAnalysis.osFrequency && Object.keys(userAgentAnalysis.osFrequency).length > 0))  ">

            <!-- <div class="col-1 "/> -->

              <div v-if="userAgentAnalysis && userAgentAnalysis.browserFrequency && Object.keys(userAgentAnalysis.browserFrequency).length > 0 " class="col-12 col-lg-6 pr-lg-2">
                <BrowserType :browserFrequency="userAgentAnalysis.browserFrequency == null ? null : userAgentAnalysis.browserFrequency   "></BrowserType>
              </div>

              <!-- <div class="col-2 "/> -->

              <div v-if="userAgentAnalysis && userAgentAnalysis.osFrequency && Object.keys(userAgentAnalysis.osFrequency).length > 0 " class="col-12 col-lg-6 mt-4 mt-lg-0 pl-lg-2">
                <DeviceOs :osFrequency="userAgentAnalysis.osFrequency == null ? null :userAgentAnalysis.osFrequency "></DeviceOs>
              </div>

          
              <div class="col-2"/>
        </div>


        <!-- Scans distribués / Sacs scannés -->
<!--         <div class="row mt-5 ">
            <div v-show="cumulativeData" class="col-md-12 col-12 pr-md-2 pr-0 ">
                <SplineChart :cumulativeData="cumulativeData == null ? null : cumulativeData" :name="$t('campaign.label.series1SplineChart')" :name1="$t('campaign.label.series2SplineChart')" :title="$t('campaign.card.splineChart')" />
            </div>
        </div> -->




        <!-- 2x Pie charts -->
        <div class="row mt-md-5 mt-2 p-md-0 p-3" v-if="deliveredByCity">

          
          <div v-if="deliveredByCity" class="col-12 col-lg-6 pr-lg-2">
              <MovmentBag :deliveredByCity="deliveredByCity" />
            </div>

            <div class="col-12 col-lg-6 mt-4 mt-lg-0 pl-lg-2">
            </div>
            <!-- <div class="col-12 col-lg-6 mt-4 mt-lg-0 pl-lg-2">
              <DistributionState :totalDelivered="totalDelivered" ></DistributionState>
            </div> -->


        </div>



      <!-- Timeline -->
      <TimeLineCampaign class="pt-0 mt-md-5 mt-2 p-md-0 p-3" :selectedcampaign="campaignReport" v-if="this.campaignReport && !this.campaignReport.campaignWithOutBags"/>
      

        <!-- Collected Data -->
        <div v-if="this.selectedcampaign && this.selectedcampaign.id" class="row mt-md-5 mt-2 p-md-0 p-3 ">
          <div  class="col-12">
            <CollectingData  :campaignId="this.selectedcampaign.id"></CollectingData>
          </div>
        </div>

        <div v-if="this.selectedcampaign && this.selectedcampaign.id && this.selectedcampaign.isWithGift" class="row">
          <div  class="col-12">
            <GiftWinner :firstDay="start" :lastDay="end" :campaignId="this.selectedcampaign.id"></GiftWinner>
          </div>
        </div>

        <!-- 1x Pie charts -->
        <div class="row mt-md-3 mt-2 p-md-0 p-3">
          
          <div  v-if="ageRangeRate &&   ageRangeRate.values.length && ageRangeRate.labels.length " class="col-md-6 col-12 pr-lg-2" >
            <AgeRangeRate :ageRangeRate="ageRangeRate" ></AgeRangeRate>
          </div>

          <div  v-if="genderRate &&   genderRate.count.length && genderRate.labels.length " class="col-md-6 col-12 pr-lg-2 mt-4 mt-lg-0" >
            <GenderRate :genderRate="genderRate" ></GenderRate>
          </div>

          <div  v-if="customDropDownRate  " class="col-md-6 col-12 pr-lg-2 mt-2" >
            <CustomDropDownRate :customDropDownRate="customDropDownRate" ></CustomDropDownRate>
          </div>
         

        </div>

 
        <div class="card mt-md-3 mt-2 m-md-0 m-3" v-if="this.selectedcampaign && this.selectedcampaign.imagesCampaign &&  this.selectedcampaign.imagesCampaign.length">
          <div class="card-body p-4">
            <h4 class="text-dark text-uppercase font-weight-bold">{{$t('campaign.card.medias')}}</h4>
  
                <div v-if="imagesMap && Object.keys(imagesMap).length" class="row mt-3">
                  <div class="col-lg-2 col-sm-4 col-md-3 col-12 text-center p-2" v-for="(image, code) in imagesMap" :key="code">
                          <img width="100%" height="auto" alt="" :src="image" style="border-radius:8px;"  loading="lazy"/>
                  </div>
                </div>

                <div v-if="vediosMap && Object.keys(vediosMap).length" class="row mt-3">
                  <div class="col-lg-2 col-sm-4 col-md-3 col-12 text-center p-2" v-for="(vedio, code) in vediosMap" :key="code">
                      <video width="200" height="200" class="banner-video-mobile" loop playsinline autoplay muted >
                          <source :src="vedio" type="video/mp4" >
                      </video>	
                  </div>
                </div>

                <!--div v-if="imageVideoIndex < selectedcampaign.imagesCampaign.length" class="row mt-4 pt-3">
                  <div class="col-12 text-center">
                    <a  @click="loadMoreImages" class="text-primary mt-4" style="cursor: pointer;">{{$t('campaign.card.loadMore')}}</a>
                    
                    </div>
                    <div class="col-12 text-center mt-1">
                      <a  @click="loadMoreImages" style="cursor: pointer;">
                        <img alt="Next Step" width="15px" src="@/assets/icons/down.svg" />
                      </a>
                    </div>
                </div-->
            
          </div>
        </div>

        <div class="text-center text-md-right mt-3 mb-md-0 mb-5" v-if="this.selectedcampaign">
          <b-button variant="outline-info text-uppercase" class="mt-2" style="width: 250px;" @click="repeatExperience()">
            {{$t("campaign.text.refaire")}}
          </b-button>
        </div>

        <div v-if=" this.showError" class="text-center text-danger"> {{ $t('campaign.error.notFound') }}</div>




      </div>

        <div v-else>
      <div class="mt-md-3 mt-2 m-md-0 m-3" >
        <SettingsQrCampaign :campaign="selectedcampaign" @refreshCampaign="refresh"></SettingsQrCampaign>
      </div>

    </div>



    </div>

    <b-modal
          v-model="showCampaignList"
          v-if="campaignList"
          hide-footer
          centered
          title-class="text-primary"
          title-tag="h5"
          header-close-variant="danger"
          hide-header

          size="xl">

          <h4 class="text-primary font-weight-bold mb-4 mt-3">{{$t("campaign.modal.title")}} </h4>

          <div class="table-responsive"> 
                <b-table 
                :busy="isCampaignTableBusy"
                :striped="true"
                :small="false"
                :hover="true"
                :items="campaignList"
                :fields="campaignListFields"
                :perPage="pagemodelMain.perPage"
                selectable
                @row-clicked="onRowClicked"
                class="table"
                >
                <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                </template>

                
                <template v-slot:head(timeStamp)>
                {{ $t("campaign.table.head.timeStamp") }} 
                </template>
                <template v-slot:head(name)>
                  {{ $t("campaign.table.head.name") }} 
                </template>
                <template v-slot:head(quantityBagAsString)>
                  {{ $t("campaign.table.head.quantityBag") }}
                </template>
                <template v-slot:head(start)>
                  {{ $t("campaign.table.head.start") }} 
                </template>
                <template v-slot:head(end)>
                  {{ $t("campaign.table.head.end") }} 
                </template>
                <template v-slot:head(quantityBag)>
                  {{ $t("campaign.table.head.quantityBag") }} 
                </template>

             
                <template v-slot:cell(actions)="{item}">
                    <b-button variant="outline-primary" size="sm" @click="onRowClicked(item);" class="mr-2 ml-2" >
                      {{ $t('campaign.change') }}
                    </b-button>
                </template>

            
                </b-table>
                <span v-if="!isCampaignTableBusy & !campaignList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("subscription.table.empty")}}</span>
            </div>
            <!-- Pagination -->
            <div class="row pt-3 mb-sm-4">
                <div class="col-sm-8">
                    <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                        <b-form-select @input="findCampaign()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                        <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} {{ $t("pagination.lines") }}</span></div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="pagemodelMain.currentPage" :disabled="isCampaignTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findCampaign()" ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div> 
            <!-- Fin Pagination  -->



          

        </b-modal>


</div>


</template>


<style scoped>
.gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.gallery-images {
  flex: 1 1 calc(15% - 10px);
  box-sizing: border-box;
  position: relative;
}

.media-container {
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 250px;
}
.media-images {
  max-width: 250px;
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: filter 0.3s ease;
  position: relative;
  z-index: 1;
}


@media (max-width: 768px) {
  .gallery-images {
    flex: 1 1 calc(50% - 10px);
  }
}

@media (max-width: 480px) {
  .gallery-images {
    flex: 1 1 100%;
  }
}

</style>









